var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M3 8.25V14.25C3 15.0784 3.67157 15.75 4.5 15.75H13.5C14.3284 15.75 15 15.0784 15 14.25V8.25",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8",
    d: "M4.5 3.375C4.5 2.33947 5.33947 1.5 6.375 1.5V1.5C7.82475 1.5 9 2.67525 9 4.125V5.25H6.375C5.33947 5.25 4.5 4.41053 4.5 3.375V3.375Z",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 9",
    d: "M13.5 3.375C13.5 2.33947 12.6605 1.5 11.625 1.5V1.5C10.1753 1.5 9 2.67525 9 4.125V5.25H11.625C12.6605 5.25 13.5 4.41053 13.5 3.375V3.375Z",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M2.25 5.25H15.75V8.25H2.25V5.25Z",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M9 8.25V15.75",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarter);
export default __webpack_public_path__ + "static/media/barter.6551c22be2cdb62ee5ac5dc563ab8562.svg";
export { ForwardRef as ReactComponent };